(function () {
var $a852dad7cfc9f6fe$exports = {};
// (() => {
//   const refs = {
//     openModalBtn: document.querySelector('[data-open-thanks]'),
//     closeModalBtn: document.querySelector('[data-close-thanks]'),
//     backdrop5: document.querySelector('[data-backdrop-thanks]'),
//   };
//   refs.openModalBtn.addEventListener('click', toggleModal);
//   refs.closeModalBtn.addEventListener('click', toggleModal);
//   refs.backdrop5.addEventListener('click', logBackdropClick);
//   function toggleModal() {
//     refs.backdrop5.classList.toggle('is-hidden-thanks');
//   }
// })();

})();
//# sourceMappingURL=index.9704862e.js.map
